import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Loader from 'components/Loader'
import HourlyScrapReportHeader from 'reports/hourlyScrap/HourlyScrapReportHeader'
import HourlyScrapReportLocations from 'reports/hourlyScrap/HourlyScrapReportLocations'
import HourlyScrapReportGraph from 'reports/hourlyScrap/HourlyScrapReportGraph'

const HourlyScrapReport = ({ isLoaded, plant }) => {
  if (isLoaded) {
    return (
      <React.Fragment>
        <HourlyScrapReportHeader />
        <HourlyScrapReportLocations />
        <HourlyScrapReportGraph />
      </React.Fragment>
    )
  } else {
    return <Loader full />
  }
}

HourlyScrapReport.propTypes = {
  isLoaded: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  isLoaded: state.init.isFinished
})

export default connect(mapStateToProps)(HourlyScrapReport)
